declare const window: any;
export function CofirmPlaniLiterals(t: any) {
  return {
    titlePage: t("titlePage"),
    title: t("title"),
    description:t("description"),
    leftButton: {
      type:  t("leftButton.type"),
      text: t("leftButton.text"),
      id: t("leftButton.id"),
    },
    imageSection: {
      name: t("imageSection.name"),
      alt: t("imageSection.alt"),
    },
    messageSucces: {
      title: t("messageSucces.title"),
      desc: t("messageSucces.desc")
    },
    messageFail: {
      title: t("messageFail.title"),
      desc: t("messageFail.desc")
    },
    globickButton: {
      type: t("globickButton.type"),
      text: t("globickButton.text"),
      id: t("globickButton.id")
    }
  };
}

